import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ContactForm from "@/components/ContactForm";
import MobileCallButton from "@/components/MobileCallButton";

const Contact = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main id="main-content" className="pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-foreground mb-4">Get in Touch</h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Ready to transform your IT? Contact our friendly Swansea-based team for a free consultation.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="lg:col-span-2">
              <div className="bg-card rounded-xl shadow-soft p-8 border border-border">
                <h2 className="text-2xl font-semibold mb-6">Send us a message</h2>
                <ContactForm />
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-card rounded-xl shadow-soft p-6 border border-border">
                <h3 className="font-semibold text-lg mb-4">Contact Details</h3>
                <div className="space-y-4">
                  <a
                    href="tel:+441234567890"
                    className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors"
                  >
                    <Phone className="h-5 w-5 text-primary" />
                    01792 567 890
                  </a>
                  <a
                    href="mailto:info@coblynausolutions.co.uk"
                    className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors"
                  >
                    <Mail className="h-5 w-5 text-primary" />
                    info@coblynausolutions.co.uk
                  </a>
                  <div className="flex items-center gap-3 text-muted-foreground">
                    <MapPin className="h-5 w-5 text-primary flex-shrink-0" />
                    Swansea, Wales
                  </div>
                  <div className="flex items-center gap-3 text-muted-foreground">
                    <Clock className="h-5 w-5 text-primary flex-shrink-0" />
                    Mon-Fri: 9am - 5:30pm
                  </div>
                </div>
              </div>

              <div className="bg-primary rounded-xl p-6 text-primary-foreground">
                <h3 className="font-semibold text-lg mb-2">Need urgent help?</h3>
                <p className="text-primary-foreground/90 text-sm mb-4">
                  For critical IT issues, call us directly for immediate support.
                </p>
                <a href="tel:+441234567890" className="inline-flex items-center gap-2 font-medium hover:underline">
                  <Phone className="h-4 w-4" />
                  Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <MobileCallButton />
    </div>
  );
};

export default Contact;
